import * as React from "react";
import { ComponentProps } from "react";
import {
  addToolbarButton,
  createModule,
  LightboxProps,
  makeUseContext,
  PLUGIN_CAPTIONS,
  PluginProps,
  useLightboxProps
} from 'yet-another-react-lightbox'
import { MySlide } from '@/models/albumFile.ts'
import { IconCamera } from '@tabler/icons-react'

// import { addToolbarButton, createModule, PLUGIN_CAPTIONS, PluginProps } from "../../index.js";
// import { Title } from "./Title.js";
// import { Description } from "./Description.js";
// import { CaptionsButton } from "./CaptionsButton.js";
// import { CaptionsContextProvider } from "./CaptionsContext.js";
// import { resolveCaptionsProps } from "./props.js";

export const defaultCaptionsProps = {
  descriptionTextAlign: "start" as const,
  descriptionMaxLines: 3,
  showToggle: false,
  hidden: false,
};

export const resolveCaptionsProps = (captions: LightboxProps["captions"]) => ({
  ...defaultCaptionsProps,
  ...captions,
});

export function useCaptionsProps() {
  const { captions } = useLightboxProps();
  return resolveCaptionsProps(captions);
}

export const CaptionsContext = React.createContext<any | null>(null);

export const useCaptions = makeUseContext("useCaptions", "CaptionsContext", CaptionsContext);

export function CaptionsContextProvider({ captions, children }: ComponentProps<never>) {
  const { ref, hidden } = resolveCaptionsProps(captions);

  const [visible, setVisible] = React.useState(!hidden);

  const context = React.useMemo(
    () => ({
      visible,
      show: () => setVisible(true),
      hide: () => setVisible(false),
    }),
    [visible],
  );

  React.useImperativeHandle(ref, () => context, [context]);

  return <CaptionsContext.Provider value={context}>{children}</CaptionsContext.Provider>;
}

/** Captions plugin */
export function MyCaptionsLiveshow({ augment, addModule }: PluginProps) {
  augment(
    // @ts-ignore
    ({ captions: captionsProps, render: { slideFooter: renderFooter, ...restRender }, toolbar, ...restProps }) => {
      const captions  =  resolveCaptionsProps(captionsProps);
      return {
        render: {
          slideFooter: ({ slide }: {slide: MySlide}) => (
            <>
              {renderFooter?.({ slide })}
              {(slide.title || slide.description || slide.game) && <div className='absolute bottom-1 left-[50%] translate-x-[-50%] z-20 text-lg shadow w-full px-5 pb-1'>
                <div className='relative bg-primary text-neutral text-center w-full p-3 px-[4rem] rounded-2xl flex flex-col justify-stretch'>
                  <div className='absolute left-3 top-[50%] translate-y-[-50%]'><IconCamera size={32} /></div>
                  {slide.game && <p className='font-bold md:text-xl'>{slide.game.challenge}</p>}
                  {slide.title && <p>{slide.title}</p>}
                  {slide.description && <p>{slide.description}</p>}
                </div>
              </div> }
            </>
          ),
          ...restRender,
        },
        toolbar: addToolbarButton(toolbar, PLUGIN_CAPTIONS, captions.showToggle ? null : null),
        captions,
        ...restProps,
      };
    },
  );

  // @ts-ignore
  addModule(createModule(PLUGIN_CAPTIONS, CaptionsContextProvider));
}
